<template>
    <div class="pa-5">
        <v-form v-model="validForm">
            <v-row>
                <v-col cols="12">

                    {{ "Enter the number of days you want to fetch again entries from today" | t }}.
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Transaction days" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    <v-text-field class="text-field-item mb-1" dense outlined v-model="transactionDays" type="number"
                                  :rules="rules"/>
                </v-col>
                <v-col class="col-item text-center" cols="3">
                    <v-btn :disabled="!validForm" @click="handleDownloadAccountData">{{ "Download" | t }}</v-btn>
                </v-col>

            </v-row>
        </v-form>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
    name: "consent-account-transaction-days-tab",
    data() {
        return {
            loading: true,
            transactionDays: 90,
            validForm: true,
            rules: [
                v => !!v || 'Required',
                v => v >= 1 || 'Transaction days must be greater than 0 days',
                v => v <= 90 || "Transaction days can't be above 90 days",
            ],
        }
    },
    computed: {
        ...mapState('ais', ['activeAccount']),
    },
    methods: {
        ...mapActions('ais', ['downloadAccountData']),
        ...mapMutations('ais', ['resetActiveAccount']),
        async handleDownloadAccountData() {
            if (this.transactionDays < 0 || this.transactionDays > 90) return
            const result = await this.downloadAccountData({
                accountId: this.activeAccount.id,
                transactionDays: this.transactionDays
            })
            if (result) this.resetActiveAccount();
        }
    }
}
</script>

<style scoped>
.row-title {
    color: gray;
    padding-top: 15px;
}
</style>